import {ClassDescriptor, FieldDescriptor, MethodDescriptor, ParamListType, SpecificConstructor} from "common";

export class ClassDescriptorClass implements ClassDescriptor
{
	name: string;
	methods: { [key: string]: MethodDescriptor };
	fields: { [key: string]: FieldDescriptor };
	constructorParameters: ParamListType;
	description: string;
	ctor: SpecificConstructor;

	constructor(constructor: SpecificConstructor, params: ParamListType, description: string)
	{
		this.description = description;
		this.name = constructor.name;
		this.methods = {};
		this.fields = {};
		this.constructorParameters = params;
		this.ctor = constructor;

		// // Use reflection to get the names of the constructor parameters
		// const paramRegEx = /constructor\(([^)]*)\)/;
		// const constructorString = constructor.toString();
		// const paramMatch = paramRegEx.exec(constructorString);

		// Check if the match was successful and parameters were found
		// if (paramMatch && paramMatch[1])
		// {
		// 	// Split the parameters string into an array of parameter names
		// 	this.constructorParameters = paramMatch[1].split(',').map(param => param.trim());
		// }
		// else
		// {
		// 	// If no parameters, set to an empty array
		// 	this.constructorParameters = [];
		// }
	}
	allowConstructor!: boolean;
}